<template>

  <div class="container">
    <b-row>
      <b-col>
        <h1 class="heading">
          Licenses
        </h1>

        <p style="text-align: justify;">
          AMIE requires that all source code that is available through the CropMRepository is licensed.

        </p>
        <p style="text-align: justify;">
          The main goal of AMEI is to support crop growth model improvements by providing the scientific community
          freely available models and model components. Therefore, AMEI urges model developers to choose an open-source
          license compatible with the General Public License version 3.0 (GPLv3.0) that allows models to be coupled with
          other models so that other people can use them.
        </p>
        <div class="d-flex w-100 justify-content-between">
          <div>
            <div class="d-flex w-100 align-items-start">
              <h5 class="mb-1">
                Below is a list of approved licenses by the Free Software Foundation (<b-link
            target="_blank"
            href="https://www.fsf.org/"
            class="text-decoration-none">FSF</b-link>) and Open Source Initiative
                (<b-link
            target="_blank"
            href="https://opensource.org/licenses"
            class="text-decoration-none">OSI</b-link>) that AMEI recommends:
              </h5>
            </div>
          </div>
        </div>
        <b-list-group>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              Artistic License 2.0
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              Berkeley Database License
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              modified BSD license
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              Boost Software License
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              Cryptix General License
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              Eiffel Forum License version2
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              GNU General Public License v3.0
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              GNU Lesser General Public License
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              Intel Open Source License
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              ISC license
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              X11 (MIT) license
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              Python Software Foundation License 2.0.1, 2.1.1 and newer
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              W3C Software Notice and License
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              zlib/libpng license
            </p>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <p class="text-left mb-1">
              Zope Public License version 2.0
            </p>
          </b-list-group-item>

        </b-list-group>
      </b-col>
    </b-row>
  </div>

</template>
<script>


export default {
  name: 'About_Licenses',

  data() {
    return {}
  },

  components: {},

  async created() {

  },

  async mounted() {

  }

}
</script>

<style scoped>

ul.myListStyle {
  list-style-type: none;
}

#about {
  height: 80vh;
  width: 100%;
}

#recentModels {
  text-align: left;
}


</style>
